import type { PlanStatus } from '@/types'
import type { WavePlanStatusValue } from '@/api/wavePlans'
import { getStatusBadgeClassName, getStatusLabel } from '@/utils/statusConfig'

export function WavePlanStatus({
  status,
}: {
  status: PlanStatus | WavePlanStatusValue
}) {
  if (status === 'NOT_STARTED')
    return (
      <span className="inline-flex items-center justify-center rounded border border-dashed border-border px-3 py-0.5 text-sm font-medium text-muted-foreground">
        Not started
      </span>
    )
  return (
    <span
      className={`inline-flex items-center justify-center rounded px-3 py-0.5 text-sm font-medium ${getStatusBadgeClassName(status)}`}
    >
      {getStatusLabel(status)}
    </span>
  )
}
